import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["image", "card", "body", "bodyText"];

  static values = {
    index: { type: Number, default: 0 },
  };

  connect() {
    const observer = new IntersectionObserver(this.onIntersection);

    observer.observe(this.element);

    this.spaceObserver = new ResizeObserver(this.reserveSpace);
    [...this.bodyTextTargets, ...this.imageTargets].forEach((element) =>
      this.spaceObserver.observe(element),
    );
  }

  disconnect() {
    clearInterval(this.cyclingInterval);
    this.spaceObserver.disconnect();
  }

  reserveSpace = () => {
    if (this.reservedWidth !== this.element.clientWidth) {
      this.reservedWidth = this.element.clientWidth;
      this.element.style.removeProperty("--carousel-body-height");
      this.element.style.removeProperty("--carousel-pane-height");
    }

    this.reserveTallest("--carousel-body-height", this.bodyTextTargets);
    this.reserveTallest("--carousel-pane-height", this.imageTargets);
  };

  reserveTallest(property, elements) {
    const reserved =
      parseFloat(this.element.style.getPropertyValue(property)) || 0;
    const tallest = Math.max(
      reserved,
      ...elements.map((element) => element.offsetHeight),
    );

    this.element.style.setProperty(property, `${tallest}px`);
  }

  startCardCycling() {
    this.cyclingInterval = setInterval(
      this.incrementSelection.bind(this),
      3000,
    );
  }

  incrementSelection() {
    const newValue = this.indexValue + 1;

    if (newValue >= this.imageTargets.length) {
      this.indexValue = 0;
    } else {
      this.indexValue = newValue;
    }
  }

  onIntersection = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.startCardCycling();
        observer.unobserve(this.element);
      }
    });
  };

  change(event) {
    clearInterval(this.cyclingInterval);

    this.indexValue = this.cardTargets.indexOf(event.currentTarget);
  }

  indexValueChanged(value) {
    this.cardTargets.forEach((card, index) => {
      ["lg:bg-gradient"].forEach((klass) => {
        card.classList.toggle(klass, index == value);
      });
    });

    this.imageTargets.forEach((image, index) => {
      image.classList.toggle("invisible", index != value);
    });

    this.bodyTargets.forEach((body, index) => {
      body.toggleAttribute("data-active", index === value);
    });
  }
}
